import CustomEditor from "../Editor/CustomEditor";
import { StartNode } from "../Editor/StartNode/StartNode";
import {
  AddConnectionCommand,
  RemoveConnectionCommand
} from "./ConnectionCommand";
import History from "./History";
import {
  AddNodeCommand,
  NodeTranslateCommand,
  RemoveNodeCommand
} from "./NodeCommand";

let _editor: CustomEditor | null = null;

function keyboardEvents(ev: KeyboardEvent) {
  if (_editor && ev.ctrlKey) {
    if (ev.code === 'KeyZ') _editor.trigger('undo')
    if (ev.code === 'KeyY') _editor.trigger('redo')
  }
}

export function init(editor: CustomEditor) {
  _editor = editor;

  editor.bind('undo')
  editor.bind('redo')

  editor
    .on('nodetranslated', ({ node, prev }) => {
      const lastRecord = History.getLastRecord()

      if (lastRecord instanceof NodeTranslateCommand && lastRecord.node.id === node.id) {
        lastRecord.newPos = [ ...node.position ]
      } else {
        History.addToStack(new NodeTranslateCommand(editor, node, prev))
      }
    })
    .on('nodecreated', (node) => {
      if (!(node instanceof StartNode)) {
        History.addToStack(new AddNodeCommand(editor, node))
      }
    })
    .on('noderemoved', (node) => {
      History.addToStack(new RemoveNodeCommand(editor, node))
    })
    .on('connectioncreated', (connection) => {
      History.addToStack(new AddConnectionCommand(editor, connection))
    })
    .on('connectionremoved', (connection) => {
      History.addToStack(new RemoveConnectionCommand(editor, connection))
    })
    .on('undo', () => {
      History.undo()
    })
    .on('redo', () => {
      History.redo()
    })

  document.addEventListener('keydown', keyboardEvents)
}

export function destroy() {
  _editor = null

  document.removeEventListener('keydown', keyboardEvents)
}

export default {
  init,
  destroy
}
